module.exports = __webpack_public_path__ + "static/img/ai_pic.e8add3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai_pic.png
// module id = KhhC
// module chunks = 1